import React from "react";
import { render } from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css"; //TODO
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import App from "./components/routes/App";
import Firebase, { FirebaseContext } from "./components/Firebase";
import configureStore from "./redux/configureStore";
import { Provider as ReduxProvider } from "react-redux";

const store = configureStore();

render(
  <ReduxProvider store={store}>
    <Router>
      {/* <FirebaseContext.Provider value={new Firebase()}> */}
      <App />
      {/* </FirebaseContext.Provider> */}
    </Router>
  </ReduxProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
